import type { ItemAttributes, ItemNames } from '@ps-smart-cp/ppfw-client';
import { Characters, ItemName, Locale, SingleDate } from '@ps-smart-cp/ppfw-client';

/**
 * 繰越
 */
interface Schema {
  // 処理月度
  readonly processingMonth: Date | null;

  // 決算締め状態
  readonly carryOverState: string;

  // 事業年度
  readonly businessYear: string;

  // 期首年月
  readonly beginningYm: Date | null;
}

const attributes = {
  processingMonth: SingleDate.ym(),
  carryOverState: Characters.preset.freeFormat(),
  businessYear: Characters.preset.freeFormat({ maxLen: 4 }),
  beginningYm: Characters.preset.freeFormat(),
} satisfies ItemAttributes<Schema>;

interface Record {
  readonly processingMonth: string;
  readonly carryOverState: string;
  readonly businessYear: string;
  readonly beginningYm: string;
  readonly sysState: string;
}

const names = {
  processingMonth: ItemName.of([Locale.ja, '処理月度'], [Locale.en, 'Processing Month']),
  carryOverState: ItemName.of([Locale.ja, '決算締め状態'], [Locale.en, 'Final Account Status']),
  businessYear: ItemName.of([Locale.ja, '事業年度'], [Locale.en, 'Business Year']),
  beginningYm: ItemName.of([Locale.ja, '期首年月'], [Locale.en, 'Beginning year Month']),
} satisfies ItemNames<Schema>;

const labelNames = {
  carryOverSettingTitle: ItemName.of([Locale.ja, '月次繰越'], [Locale.en, 'Company Information Settings']),
  carryOverNow: ItemName.of([Locale.ja, '現在'], [Locale.en, 'Carry Over Now']),
  carryOverAfter: ItemName.of([Locale.ja, '繰越後'], [Locale.en, 'Carry Over After']),
  beginningCarryOverSettingTitle: ItemName.of(
    [Locale.ja, '期首繰越'],
    [Locale.en, 'Company Information Settings'],
  ),
  toCarryOver: ItemName.of([Locale.ja, '繰越画面へ'], [Locale.en, 'To Carry Over']),
  closingStateCheck: ItemName.of([Locale.ja, '決算状況確認'], [Locale.en, 'Closing State Check']),
  currentAccountingPeriod: ItemName.of(
    [Locale.ja, '現在の会計期間'],
    [Locale.en, 'Current Accounting Period'],
  ),
};

const carryOver = {
  names,
  labelNames,
  attributes,
};

interface CarryOver {
  schema: Schema;
  record: Record;
}

export type { CarryOver };
export { carryOver };
